import { useRouter } from 'next/router';

import { Box, Heading } from '@zillow/constellation-10';

import {
  wizardFormColumnStyles,
  wizardFormSectionContainerStyles,
  wizardGridContainerStyles,
  wizardHeadingStyles,
} from '../../../../styles/wizard';
import MapPinAdjustmentAlert from '../../../PostingPath/MapPinAdjustmentAlert';
import RoomForRentByFormField from '../../../PostingPath/RoomForRentByFormField';
import PageWizard from '../../../Wizard/PageWizard';
import type { WizardBodyTemplateProps } from '../../../WizardStepController';

const RoomWhoIsListingProperty = ({
  onGoToNextStep,
  onGoToPrevStep,
  onExitWizard,
  wizardTitle,
  progressStepper,
  totalSteps,
  currentStepIndex,
  ...rest
}: WizardBodyTemplateProps) => {
  const router = useRouter();
  const listingAlias = router.query.listingAlias as string;

  return (
    <PageWizard
      {...rest}
      title=""
      wizardTitle={wizardTitle}
      progressStepper={progressStepper}
      totalSteps={totalSteps}
      currentStepIndex={currentStepIndex}
      onNextClick={onGoToNextStep || undefined}
      onBackClick={onGoToPrevStep || undefined}
      onExitTriggered={onExitWizard}
      hideBackButton={true}
    >
      <Box css={wizardGridContainerStyles}>
        <Box css={wizardFormColumnStyles}>
          <Box css={wizardFormSectionContainerStyles.raw()}>
            <MapPinAdjustmentAlert listingAlias={listingAlias} />

            <Heading level={2} textStyle="heading-sm" css={wizardHeadingStyles}>
              Who’s listing the room for rent?
            </Heading>

            <RoomForRentByFormField />
          </Box>
        </Box>
      </Box>
    </PageWizard>
  );
};

export default RoomWhoIsListingProperty;
